import { nnSlideUp, nnSlideDown } from './helpers.js';

export function accordions() {
    const $accordionTriggers = document.querySelectorAll('.accordion summary');

    $accordionTriggers?.forEach($el => {
        $el.addEventListener('click', accordClick);
    });
}

function accordClick(e) {
    e.preventDefault();
    const $thisAccordion = e.target.closest('.accordion');
    const $thisContent = $thisAccordion.querySelector('.accordion__content');
    const animDuration = 400;

    if ( !$thisAccordion.hasAttribute('open') ) {
        $thisAccordion.setAttribute('open', '');
        $thisAccordion.classList.add('active');
        nnSlideDown($thisContent, animDuration);
    } else {
        nnSlideUp($thisContent, animDuration);
        $thisAccordion.classList.remove('active');
        setTimeout(function() {
            $thisAccordion.removeAttribute('open');
        }, 510);
    }
}